<template>
  <div class="wh100">
    <el-row :gutter="gutter">
      <el-col :span="span[0]">
        <slot name="left"></slot>
      </el-col>
      <el-col :span="span[1]">
        <slot name="right"></slot>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "layoutleftright",
  props: {
    span: {
      type: Array,
      default: function() {
        return [12, 12];
      }
    },
    gutter: {
      type: Number,
      default: 0
    }
  }
};
</script>
<style lang="less" scoped>
.el-row {
  height: 100%;
}
.el-col {
  height: 100%;
}
</style>